// extracted by mini-css-extract-plugin
export default {"btn":"ScrollToTop_btn__Uz+uA"};